<template>
  <section>
    <!-- Store Summary Cards (Exact 4 Cards) -->
    <KpiCards class="mb-3" :items="kpiItems" :loading="!storeSummaries.length" :skeleton="4" />
    <data-table
      :headers="headers"
      :items="stores"
      commit="SET_STORES"
      :viewItem="viewItem"
      :editItem="editItem"
      :deleteItem="storeAction"
    >
      <div slot="activator" class="row justify-sm-space-between mb-4">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
          <div class="d-flex">
            <v-card-title class="py-0 pl-0 ps-products-title">
              {{ $t("stores") }}
            </v-card-title>
            <div class="br-tabs ml-2">
              <div
                v-for="(val, i) in status_list"
                :key="i"
                class="br-tab"
                :class="{ 'br-tab--active': status_filter === val.value }"
                @click="status_filter = val.value"
              >
                {{ $t(val.text) }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
          <TextSearch
            v-model="search"
            @search="fetchItem()"
            @onClear="
              search = '';
              fetchItem();
            "
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 text-right">
          <v-btn
            depressed
            color="primary"
            @click="newItem"
          >
            <v-icon left>fal fa-plus-circle</v-icon>
            {{ $t("add_new") }}
          </v-btn>
        </div>
      </div>
    </data-table>
    <app-custom-dialog
      v-model="dialog"
      width="800px"
      :footer="false"
      title="details"
    >
      <div slot="activator">
        <v-row>
          <v-col xs="12" sm="12" md="6" lg="6" xl="6">
            <v-row>
              <v-col cols="5">{{ $t("id") }}</v-col>
              <v-col cols="7">{{ form.id }}</v-col>
              <v-col cols="5">{{ $t("logo") }}</v-col>
              <v-col cols="7">
                <v-avatar tile size="35">
                  <v-btn text @click="openURL(form.logo)">
                    <app-img :img="form.logo" />
                  </v-btn>
                </v-avatar>
              </v-col>
              <v-col cols="5">{{ $t("name") }}</v-col>
              <v-col cols="7">{{ form.name }}</v-col>
              <v-col cols="5">{{ $t("package") }}</v-col>
              <v-col cols="7">
                <v-chip
                  v-if="form.package && form.package.name"
                  label
                  dark
                  :color="packageName(form.package.name).color"
                  small
                  class="text-capitalize"
                >
                  {{ packageName(form.package.name).text }}</v-chip
                ></v-col
              >

              <v-col cols="5">{{ $t("phone_no") }}</v-col>
              <v-col cols="7">{{ form.phone_no }}</v-col>
              <v-col cols="5">{{ $t("mobile_no") }}</v-col>
              <v-col cols="7">{{ form.mobile_no }}</v-col>
              <v-col cols="5">{{ $t("address") }}</v-col>
              <v-col cols="7">{{ form.address }}</v-col>
              <v-col cols="5">{{ $t("start_date") }}</v-col>
              <v-col cols="7">{{ form.start_date }}</v-col>
              <v-col cols="5">{{ $t("end_date") }} </v-col>
              <v-col cols="7"
                >{{ form.end_date }}
                <v-btn @click="sendWhatsapp(form)" color="green" small dark>
                  <v-icon left>fab fa-whatsapp</v-icon>
                  {{ $t("send_notify") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col xs="12" sm="12" md="6" lg="6" xl="6">
            <v-row>
              <v-col cols="5">{{ $t("is_online") }}</v-col>
              <v-col cols="7">{{ form.is_online }}</v-col>
              <v-col cols="5">{{ $t("product_count") }}</v-col>
              <v-col cols="7">{{ form.product_count | ToNumber }}</v-col>
              <v-col cols="5">{{ $t("all_products") }}</v-col>
              <v-col cols="7">{{ form.products_count | ToNumber }}</v-col>
              <v-col cols="5">{{ $t("categories_count") }}</v-col>
              <v-col cols="7">{{ form.categories_count | ToNumber }}</v-col>
              <v-col cols="5">{{ $t("tickets_count") }}</v-col>
              <v-col cols="7">
                <v-btn
                  depressed
                  small
                  dark
                  color="primary"
                  :to="`/administrator/store-ticket/` + form.id"
                >
                  {{ form.tickets_count | ToNumber }}
                </v-btn>
              </v-col>
              <v-col cols="5">{{ $t("users_count") }}</v-col>
              <v-col cols="7">{{ form.stores_user_count | ToNumber }}</v-col>
              <v-col cols="5">{{ $t("customers_count") }}</v-col>
              <v-col cols="7">{{ form.customers_count | ToNumber }}</v-col>
              <v-col cols="5">{{ $t("branches_count") }}</v-col>
              <v-col cols="7">{{ form.branches_count | ToNumber }}</v-col>
              <v-col cols="5">{{ $t("date") }}</v-col>
              <v-col cols="7">{{ form.created_at | moment }}</v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="text-right">
            <template v-if="form.join === 'processing'">
              <v-btn
                class="mr-2"
                color="primary"
                @click="joinSubmit('approved', 'is_approved_purchase')"
              >
                <v-icon small left> fal fa-check-circle </v-icon>
                {{ $t("approved") }}
              </v-btn>
              <v-btn
                color="red"
                @click="joinSubmit('decline', 'rejected_online_request')"
              >
                <v-icon small left> fal fa-times-circle </v-icon>
                {{ $t("rejected") }}
              </v-btn>
            </template>
            <v-btn
              v-if="form.join === 'approved'"
              color="red"
              @click="joinSubmit('cancel', 'cancel_online_request')"
            >
              <v-icon small left> fal fa-times-circle </v-icon>
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              v-if="form.join === 'pending'"
              color="primary"
              @click="joinSubmit('pending', 'join_e_commerce')"
            >
              <v-icon small left> fal fa-plus-circle </v-icon>
              {{ $t("join_online") }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </app-custom-dialog>
    <app-custom-dialog
      v-model="dialogAdd"
      :footer="true"
      :title="titleStatus"
      width="1200px"
      @submit="submitForm"
    >
      <div slot="activator">
        <v-container fluid class="pa-0">
          <!-- Basic Information Section -->
          <v-card outlined class="mb-4" rounded="lg" elevation="0">
            <v-card-title class="primary--text py-3 px-4">
              <v-icon left color="primary" size="20">fal fa-store</v-icon>
              {{ $t("basic_information") }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-4 px-4">
              <v-row>
                <v-col cols="12" md="6">
                  <TTextField
                    label="store_name"
                    v-model="form.name"
                    :errorMessages="nameErrors"
                    @input="$v.form.name.$touch()"
                    @blur="$v.form.name.$touch()"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <TTextField
                    label="mobile_no"
                    :maxlength="10"
                    v-model="form.mobile_no"
                    :errorMessages="mobile_noErrors"
                    @input="$v.form.mobile_no.$touch()"
                    @blur="$v.form.mobile_no.$touch()"
                  />
                </v-col>
                <v-col cols="12">
                  <TTextField
                    label="address"
                    v-model="form.address"
                    :errorMessages="addressErrors"
                    @input="$v.form.address.$touch()"
                    @blur="$v.form.address.$touch()"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Store Configuration Section -->
          <v-card outlined class="mb-4" rounded="lg" elevation="0">
            <v-card-title class="primary--text py-3 px-4">
              <v-icon left color="primary" size="20">fal fa-cog</v-icon>
              {{ $t("store_configuration") }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-4 px-4">
              <v-row>
                <v-col cols="12" md="6">
                  <div class="text-subtitle-2 mb-3 font-weight-medium">
                    <v-icon small left color="grey darken-1">fal fa-tag</v-icon>
                    {{ $t("store_type") }}
                  </div>
                  <v-radio-group
                    v-model="form.store_type_code"
                    class="mt-0"
                    row
                  >
                    <v-radio
                      v-for="(item, index) in storeList"
                      :key="index"
                      :label="$t(item.text)"
                      :value="item.value"
                      class="mr-4"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" md="6">
                  <TextSelect
                    label="owner"
                    v-model="form.userId"
                    itemValue="id"
                    text="first_name"
                    :items="users"
                    :errorMessages="userIdErrors"
                    @input="$v.form.userId.$touch()"
                    @blur="$v.form.userId.$touch()"
                  />
                </v-col>
                <v-col cols="12">
                  <div class="text-subtitle-2 mb-3 font-weight-medium">
                    <v-icon small left color="grey darken-1"
                      >fal fa-calculator</v-icon
                    >
                    {{ $t("cost_calculation_method") }}
                  </div>
                  <v-radio-group
                    v-model="form.cost_calculation_method"
                    class="mt-0"
                    row
                  >
                    <v-radio
                      v-for="(item, index) in costMethods"
                      :key="index"
                      :value="item.value"
                      class="mr-6"
                    >
                      <template v-slot:label>
                        <div class="ml-2">
                          <div class="font-weight-medium">
                            {{ $t(item.label) }}
                          </div>
                          <div class="text-caption grey--text">
                            {{ $t(item.description) }}
                          </div>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                  <v-alert dense type="info" class="mt-3" outlined>
                    <v-icon small left>fal fa-info-circle</v-icon>
                    {{ $t("cost_method_cannot_change") }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Package & Subscription Section -->
          <v-card outlined class="mb-4" rounded="lg" elevation="0">
            <v-card-title class="primary--text py-3 px-4">
              <v-icon left color="primary" size="20">fal fa-box</v-icon>
              {{ $t("package_subscription") }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-4 px-4">
              <v-row>
                <v-col cols="12" md="6">
                  <TextSelect
                    label="package"
                    v-model="form.package_id"
                    itemValue="id"
                    text="name"
                    :items="packages"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <DatePicker label="start_date" v-model="form.start_date" />
                </v-col>
                <v-col cols="12" md="3">
                  <DatePicker label="end_date" v-model="form.end_date" />
                </v-col>
                <v-col cols="12">
                  <v-chip-group active-class="primary--text">
                    <v-chip
                      outlined
                      small
                      @click="form.end_date = original_end_date"
                      color="red"
                    >
                      <v-icon left x-small>fal fa-redo</v-icon>
                      {{ $t("reset") }}
                    </v-chip>
                    <v-chip
                      v-for="month in [1, 3, 6, 12]"
                      :key="month"
                      @click="addMonths(month)"
                      outlined
                      small
                    >
                      {{ month }} {{ $t(month > 1 ? "months" : "month") }}
                    </v-chip>
                  </v-chip-group>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Limits & Quotas Section -->
          <v-card outlined class="mb-4" rounded="lg" elevation="0">
            <v-card-title class="primary--text py-3 px-4">
              <v-icon left color="primary" size="20">fal fa-chart-line</v-icon>
              {{ $t("limits_quotas") }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-4 px-4">
              <v-row>
                <v-col cols="12" md="6" lg="4">
                  <CurrencyInput
                    label="products_count"
                    v-model="form.product_count"
                  />
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <CurrencyInput
                    label="users_count"
                    v-model="form.user_count"
                  />
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <CurrencyInput
                    label="branch_count"
                    v-model="form.branch_count"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-container>
      </div>
    </app-custom-dialog>
    <!-- AppLoading -->
    <app-loading :overlay="overlay" />
  </section>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapGetters, mapActions } from "vuex";
import { storeHead } from "@/utils/head";
import TTextField from "@/components/global/TextField";
import AppDetail from "@/components/products/details";
import { myMixin } from "@/mixin/main";
import { success, confirm } from "@/controllers/alert";
import { CREATE_STORE } from "@/validations/admin";
import TextSelect from "@/components/global/TextSelect";
import { STORE_TYPE } from "@/utils/mock";
import CurrencyInput from "@/components/CurrencyInput";

// get today date
const start_date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
  .toISOString()
  .substr(0, 10);

// get end_date add 14 days
const end_date = new Date(
  Date.now() - new Date().getTimezoneOffset() * 60000 + 14 * 24 * 60 * 60 * 1000
)
  .toISOString()
  .substr(0, 10);
export default {
  mixins: [CREATE_STORE, myMixin],

  data: () => ({
    options: {
      precision: 0,
    },
    status_filter: null,
    status_list: [
      {
        value: null,
        text: "all",
      },
      {
        value: 2,
        text: "expired",
      },
      {
        value: 1,
        text: "active",
      },
      {
        value: 0,
        text: "inactive",
      },
    ],
    overlay: false,
    search: "",
    update: false,
    dialogAdd: false,
    dialog: false,
    users: [],
    packages: [],
    form: {
      name: "",
      start_date: start_date,
      end_date: end_date,
      package: {
        name: "",
      },
      package_id: null,
      product_count: 10,
      user_count: 2,
      branch_count: 1,
      customers_count: 0,
      stores_user_count: 0,
      categories_count: 0,
      products_count: 0,
      branches_count: 0,
      tickets_count: 0,
      store_type_code: "POS",
      join: "processing",
    },
    original_end_date: null,
    storeList: STORE_TYPE(),
    summaries: [],
    costMethods: [
      {
        value: "FIFO",
        label: "cost_method_fifo",
        description: "cost_method_description_fifo",
      },
      {
        value: "LIFO",
        label: "cost_method_lifo",
        description: "cost_method_description_lifo",
      },
      {
        value: "WAC",
        label: "cost_method_wac",
        description: "cost_method_description_wac",
      },
    ],
  }),
  async created() {
    await this.summary();
    await this.fetchItem();
  },
  components: {
    DataTable,
    TextSelect,
    TTextField,
    CurrencyInput,
    AppDetail,
  },

  watch: {
    status_filter() {
      this.fetchItem();
    },
  },

  computed: {
    kpiItems() {
      return (this.storeSummaries || []).map((item, index) => ({
        key: index,
        label: this.$t(item.title || item.text),
        icon: item.icon,
        value: item.total ?? 0,
        note: item.description ? this.$t(item.description) : "",
      }));
    },
    ...mapGetters({
      stores: "index/stores",
    }),

    titleStatus() {
      return this.update ? "update" : "new";
    },
    headers() {
      return storeHead(this);
    },
    storeSummaries() {
      return (this.summaries || []).slice(0, 4);
    },
  },

  methods: {
    ...mapActions({
      fetch: "index/fetch",
    }),
    async summary() {
      try {
        const { data } = await this.$http.get(`/admin_summary_store`);
        if (data.status) {
          this.summaries = data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchItem() {
      const body = {
        that: this,
        url: `admin_stores?q=${this.search}&status=${this.status_filter}`,
        commit: "SET_STORES",
      };
      await this.fetch(body);
    },

    async fetchUser() {
      try {
        const { data } = await this.$http.get(`/admin_get_users`);
        if (data.status) {
          this.users = data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchPackage() {
      try {
        const { data } = await this.$http.get(`/admin_get_package`);
        if (data.status) {
          this.packages = data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async newItem() {
      await Help.clearForm(this.form, this);
      await this.fetchItem();
      await this.fetchUser();
      await this.fetchPackage();
      this.form = {
        userId: this.users[0]?.id ?? null,
        start_date: start_date,
        end_date: end_date,
        store_type_code: "POS",
        cost_calculation_method: "WAC",
        mobile_no: "20",
        package: {},
        package_id: this.packages[0]?.id ?? null,
        product_count: 200,
        user_count: 2,
        branch_count: 1,
      };
      this.original_end_date = this.form.end_date;

      this.update = false;
      this.dialogAdd = !this.dialogAdd;
    },
    async editItem({ id }) {
      const { data } = await this.$http.get(`/admin_get_store/${id}`);
      this.form = data.data;
      this.form.userId = data.data.owner?.id;
      this.original_end_date = data.data.end_date;
      await this.fetchPackage();
      await this.fetchUser();
      this.update = true;
      this.dialogAdd = !this.dialogAdd;
    },
    async storeAction(val) {
      try {
        const title = val.is_active ? "inactive" : "active";
        const { isConfirmed } = await confirm({
          props: this,
          con_txt: `${title}_store`,
          can_txt: "clear_store",
          color_can: "#f00",
        });
        if (isConfirmed) {
          this.overlay = true;
          const { data } = await this.$http.put(`store_action/${val.id}`);
          if (data.status) {
            await Help.clearForm(this.form, this);
            await this.fetchItem();
            this.overlay = false;
            await success(this, data.message);
          }
        } else {
          await this.clearStore(val);
        }
      } catch (error) {
        console.error(error);
      }
    },

    async clearStore({ id }) {
      try {
        const { isConfirmed } = await confirm({
          props: this,
          title: `delete_store`,
          text: `delete_store_description`,
          con_txt: `yes_delete`,
          can_txt: "no_cancel",
          color_con: "#f00",
          color_can: "#5cb85c",
        });
        if (isConfirmed) {
          this.overlay = true;
          const { data } = await this.$http.delete(`clear_store/${id}`);
          if (data.status) {
            this.dialog = false;
            await Help.clearForm(this.form, this);
            await this.fetchItem();
            this.overlay = false;
            await success(this, data.message);
          }
        }
      } catch (error) {
        console.error(error);
      }
    },

    async viewItem({ id }) {
      this.$router.push(`/administrator/store/${id}`);
    },
    async submitForm() {
      try {
        this.$v.form.$touch();
        // if form is valid
        if (!this.$v.form.$invalid) {
          // check if userId is object or not
          if (typeof this.form.userId === "object") {
            this.form.userId = this.form.userId.id;
          }
          // check if package_id is object or not
          if (typeof this.form.package_id === "object") {
            this.form.package_id = this.form.package_id.id;
          }
          // remove package object from form
          delete this.form.package;
          const url = this.update ? `update_store` : `add_store`;
          const { data } = await this.$http.post(url, this.form);
          if (data.status) {
            this.dialogAdd = false;
            await Help.clearForm(this.form, this);
            await this.fetchItem();
            await success(this, data.message);
          }
        }
      } catch (error) {
        console.error(error);
      }
    },

    async joinSubmit(title, text) {
      const { isConfirmed } = await confirm({ props: this, title, text });
      if (!isConfirmed) return;
      try {
        const body = {
          status: title,
          store_id: this.form.id,
        };
        const { data } = await this.$http.post("req_join_online", body);
        if (data.status) {
          await success(this, data.message);
          this.dialog = false;
          await this.fetchItem();
        }
      } catch (error) {
        console.error(error);
      }
    },
    openURL(img) {
      const url = Help.product(img);
      window.open(url, "_blank").focus();
    },
    addMonths(months) {
      const baseDate = this.form.end_date || this.form.start_date;
      if (!baseDate) return;
      const date = new Date(baseDate);
      date.setMonth(date.getMonth() + +months);
      this.form.end_date = date.toISOString().substr(0, 10);
    },
  },
};
</script>

<style scoped>
.ps-products-title {
  font-size: 1.25rem;
  font-weight: 900;
  color: #141021;
}
</style>
